import { useEffect, useRef } from "react";
import { isMobile } from "react-device-detect";
import { Outlet } from "react-router-dom";
import { Id, ToastContainer, toast } from "react-toastify";

import { BigNumber } from "bignumber.js";
import { useAccountEffect } from "wagmi";

import { UpdateCertsToast, useCerts, useUnsupportedCerts } from "entities/cert";
import { Mobile } from "pages/mobile/mobile";
import { useSyncClaimrAuthStatusStore } from "shared/stores";
import { CloseButton } from "shared/ui/toast";
import { claimrLogout } from "shared/utils";
import { useChangeAccountEffect } from "shared/web3/hooks";

import { useCompleteQuests } from "./use-complete-snap-quest";
import { useLocalStorageMigrations } from "./use-localstorage-migrations";

BigNumber.set({
  EXPONENTIAL_AT: [-100, 100],
  ROUNDING_MODE: BigNumber.ROUND_FLOOR,
});

export const Root = () => {
  useCompleteQuests();
  useSyncClaimrAuthStatusStore();
  useLocalStorageMigrations();
  useUnsupportedCerts({
    onError: () => {
      // toast(UpdateCertsToast);
    },
  });

  const toastRef = useRef<Id | null>(null);
  const { hasUpdates } = useCerts();

  const shouldInitRef = useRef(true);

  useChangeAccountEffect((account, prevAccount) => {
    if (account.address !== prevAccount.address) claimrLogout();
  });

  useAccountEffect({
    onDisconnect: () => {
      shouldInitRef.current = false;
    },
  });

  useEffect(() => {
    if (!hasUpdates || toastRef.current) return;

    toastRef.current = toast(
      <UpdateCertsToast
        onUpdate={() => {
          toastRef.current && toast.dismiss(toastRef.current);
          toastRef.current = null;
        }}
      />,
      {
        autoClose: false,
        closeButton: false,
        onClose: () => {
          toastRef.current = null;
        },
      }
    );
  }, [hasUpdates]);

  if (isMobile) return <Mobile />;

  return (
    <>
      <Outlet />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-right"
      />
    </>
  );
};
